<template>
  <span
    class="btn btn-link text-decoration-none text-dark p-0 drag-handle"
    :class="{ disabled }"
    :title="title"
    :aria-label="title"
  >
    <i class="bi bi-grip-vertical text-dark opacity-30 fs-4" :class="iconClass"></i>
  </span>
</template>

<script>
export default {
  name: 'DragHandle',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Drag to reorder',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
};
</script>
